/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitPopularityRankingResult } from './MonitPopularityRankingResult';
import {
    MonitPopularityRankingResultFromJSON,
    MonitPopularityRankingResultFromJSONTyped,
    MonitPopularityRankingResultToJSON,
} from './MonitPopularityRankingResult';
import type { MonitPrivacyInfoResult } from './MonitPrivacyInfoResult';
import {
    MonitPrivacyInfoResultFromJSON,
    MonitPrivacyInfoResultFromJSONTyped,
    MonitPrivacyInfoResultToJSON,
} from './MonitPrivacyInfoResult';
import type { MonitPrivacyPolicyAnalysisExternalResult } from './MonitPrivacyPolicyAnalysisExternalResult';
import {
    MonitPrivacyPolicyAnalysisExternalResultFromJSON,
    MonitPrivacyPolicyAnalysisExternalResultFromJSONTyped,
    MonitPrivacyPolicyAnalysisExternalResultToJSON,
} from './MonitPrivacyPolicyAnalysisExternalResult';
import type { MonitPrivacyStatusEnum } from './MonitPrivacyStatusEnum';
import {
    MonitPrivacyStatusEnumFromJSON,
    MonitPrivacyStatusEnumFromJSONTyped,
    MonitPrivacyStatusEnumToJSON,
} from './MonitPrivacyStatusEnum';
import type { MonitPrivacyTechnologiesResult } from './MonitPrivacyTechnologiesResult';
import {
    MonitPrivacyTechnologiesResultFromJSON,
    MonitPrivacyTechnologiesResultFromJSONTyped,
    MonitPrivacyTechnologiesResultToJSON,
} from './MonitPrivacyTechnologiesResult';

/**
 * 
 * @export
 * @interface MonitPrivacyData
 */
export interface MonitPrivacyData {
    /**
     * 
     * @type {MonitPrivacyStatusEnum}
     * @memberof MonitPrivacyData
     */
    status?: MonitPrivacyStatusEnum;
    /**
     * 
     * @type {MonitPrivacyPolicyAnalysisExternalResult}
     * @memberof MonitPrivacyData
     */
    privacy_policy_analysis?: MonitPrivacyPolicyAnalysisExternalResult;
    /**
     * 
     * @type {MonitPopularityRankingResult}
     * @memberof MonitPrivacyData
     */
    popularity_ranking?: MonitPopularityRankingResult;
    /**
     * 
     * @type {MonitPrivacyInfoResult}
     * @memberof MonitPrivacyData
     */
    privacy_info?: MonitPrivacyInfoResult;
    /**
     * 
     * @type {MonitPrivacyTechnologiesResult}
     * @memberof MonitPrivacyData
     */
    technologies_found?: MonitPrivacyTechnologiesResult;
}

/**
 * Check if a given object implements the MonitPrivacyData interface.
 */
export function instanceOfMonitPrivacyData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPrivacyDataFromJSON(json: any): MonitPrivacyData {
    return MonitPrivacyDataFromJSONTyped(json, false);
}

export function MonitPrivacyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPrivacyData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : MonitPrivacyStatusEnumFromJSON(json['status']),
        'privacy_policy_analysis': !exists(json, 'privacy_policy_analysis') ? undefined : MonitPrivacyPolicyAnalysisExternalResultFromJSON(json['privacy_policy_analysis']),
        'popularity_ranking': !exists(json, 'popularity_ranking') ? undefined : MonitPopularityRankingResultFromJSON(json['popularity_ranking']),
        'privacy_info': !exists(json, 'privacy_info') ? undefined : MonitPrivacyInfoResultFromJSON(json['privacy_info']),
        'technologies_found': !exists(json, 'technologies_found') ? undefined : MonitPrivacyTechnologiesResultFromJSON(json['technologies_found']),
    };
}

export function MonitPrivacyDataToJSON(value?: MonitPrivacyData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': MonitPrivacyStatusEnumToJSON(value.status),
        'privacy_policy_analysis': MonitPrivacyPolicyAnalysisExternalResultToJSON(value.privacy_policy_analysis),
        'popularity_ranking': MonitPopularityRankingResultToJSON(value.popularity_ranking),
        'privacy_info': MonitPrivacyInfoResultToJSON(value.privacy_info),
        'technologies_found': MonitPrivacyTechnologiesResultToJSON(value.technologies_found),
    };
}

